 /**
 * Created by joellee on 11/12/15.
 */
dealershipModule.factory('settingsCacheService',['imSessionVarsService',
    function(imSessionVarsService) {

        var service = {};

        // methods to cache and retrieve settings (profit, preferences, dealer packs).
        // The cache always stores and retrieves a copy, so it is impossible modify the cache contents
        // without going through the access methods.

        // Entire cache depends on current provider code and date.
        // If either of them change, it will cause all subsequent cache reads to miss, until
        // new values are set in the cache for the new provider code and data.

        var _noProvider = "**NONE**",  // anything that cannot be a valid provider code can be used here, except null
            _noDealer =  "**NONE**",   // same restriction, but valid dealer IM id
           _providerCode = _noProvider,
           _dealerImId = _noDealer,
           _dateStr = null,
           _cache = {};

        // This is for debugging only,  internal cache object should not be used outside this service
        // service.cache = _cache;
        
        service.getCachedProfitSetting = function (productCode, date) {
            var entry = checkCache(productCode, date);
            return entry ? angular.copy(entry.profitSetting || null) : null;
        };

        service.setCachedProfitSetting  = function(productCode, date, profitSetting) {
            var entry = setCache(productCode, date);
            entry.profitSetting = angular.copy(profitSetting);
        };

        service.clearCachedProfitSettings = function() {
            clearCacheColumn('profitSetting');
        };

        service.getCachedPreferences =  function(productCode, date) {
            var entry = checkCache(productCode, date);
            return entry ? angular.copy(entry.preferences || null): null;
        };

        service.setCachedPreferences =  function(productCode, date, preferences) {
            var entry = setCache(productCode, date);
            entry.preferences = angular.copy(preferences);
        };

        service.clearCachedPreferences = function() {
            clearCacheColumn('preferences');
        };

        service.getCachedDefaultProductCodes =  function(date) {
            if (_dateStr !== date.yyyymmdd()){
                return null;
            }
            var codes = [];
            for (var prop in _cache){
                if (_cache.hasOwnProperty(prop) && _cache[prop].preferences && _cache[prop].preferences.includeDefaultProposal === 'true'){
                    codes.push(prop);
                }
            }
            return codes;
        };

        service.getCachedDealerPacks = function(productCode, date) {
            var entry = checkCache(productCode, date);
            return entry ? angular.copy(entry.dealerPacks || null): null;
        };

        service.setCachedDealerPacks = function(productCode, date, dealerPacks) {
            var entry = setCache(productCode, date);
            entry.dealerPacks = angular.copy(dealerPacks);
        };

        service.clearCachedDealerPacks = function() {
            clearCacheColumn('dealerPacks');
        };

        //KRE - COM 435
        service.clearCachedDealerProfile = function() {
            clearCacheColumn('dealerProfile');
        };

        service.getCachedDealerProfile = function(productCode, date) {
            var entry = checkCache(productCode, date);
            return entry ? angular.copy(entry.dealerProfile || null): null;
        };

        service.setCachedDealerProfile = function(productCode, date, dealerProfile) {
            var entry = setCache(productCode, date);
            entry.dealerProfile = angular.copy(dealerProfile);
        };

        service.clearCachedDealerPacks = function() {
            clearCacheColumn('dealerPacks');
        };

        service.clearCachedDealerProfile = function() {
            clearCacheColumn('dealerProfile');
        };

        service.clearCache = function() {
            _dateStr = null;
            _providerCode = _noProvider;
            _dealerImId = _noDealer;
            service.cache = _cache = {};
        };


        function clearCacheColumn(propName) {
            for (var productCode in _cache) {
                if (_cache.hasOwnProperty(productCode)) {
                    _cache[productCode][propName] = null;
                }
            }
        }

        function checkCache(productCode, date) {
            // null check may not be needed here, but we don't want true result if current provider and dealer are also null
            if (_providerCode === imSessionVarsService.getCurrentProviderCode() && _dealerImId === imSessionVarsService.getCurrentDealerIMId() && _dateStr === date.yyyymmdd()) {
                return _cache[(productCode || "").toUpperCase()];  // may be undefined
            }
            return null;
        }

        function setCache(productCode, date) {
            var providerCode = imSessionVarsService.getCurrentProviderCode();
            var dealerImId = imSessionVarsService.getCurrentDealerIMId();
            var dateStr = date.yyyymmdd();
            if (productCode == null) {
                productCode = "missing";
            }
            var productCodeUpperCase = (productCode || "").toUpperCase();
            var entry;

            if (_providerCode === providerCode && _dealerImId === dealerImId && _dateStr === dateStr) {
               entry = _cache[productCodeUpperCase];  // may be undefined

            } else {
                service.clearCache();
                _providerCode = providerCode;
                _dealerImId = dealerImId;
                _dateStr = dateStr;
            }

            if (!entry) {
                _cache[productCodeUpperCase] = entry = {};
            }

            return entry;
        }

        return service;
}]);
